import { INotificationContactPoint } from "@/Common/Api/Contacts/Dto/INotificationContactPoint";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";

class Email implements INotificationContactPoint {
    public ContactPoint_id: string = GuidHelper.Empty();
    public Address: string = "";
    public IsOkToContact: boolean = false;
    public IsPreferred: boolean = false;
    public IsVerified: boolean = false;
    public VerificationCode: string = "";
    public NotificationsEnabled: boolean = false;

    /**
     * The reference ID used for client-side rendering
     */
    public renderId: string = sessionStore.newId().toString();

    // for edition
    public IsValid: boolean = false;
    public ContactPointTypeLookupId: string = cacheStore.GetPhoneContactPointTypeLookupTuples()[0][0].LookupID;// only when Loading from PhoneNumberLight
    public AvailableContactPointTypeLookupIds: FlatLookupView[] = [];
    public isSelectedForNotification: boolean = false;

    constructor(init?: Partial<Email>) {
        Object.assign(this, init);
    }

    public static newEmail(contactPointType: ContactPointType = ContactPointType.Personal): Email {
        let email = new Email();

        email.AvailableContactPointTypeLookupIds = cacheStore.GetContactPointTypeLookups();
        email.ContactPointTypeLookupId = cacheStore.GetContactPointTypeLookups()[contactPointType].LookupID;
        email.Address = "";
        email.ContactPoint_id = GuidHelper.Empty();
        email.IsVerified = false;
        email.VerificationCode = "";

        return email;
    }

    public static IsEmpty(email: Email): boolean {
        return !email.Address?.length;
    }

    public static GetFormattedEmail(emails: Email[], position: number = 0): string {
        return emails?.[position]?.Address ?? "";
    }

    public static validateEmail(value: string): boolean {
        if (value == null || value.length == 0)
            return true;

        // fetch email validation info
        return ValidationHelper.isExactMatch(value, ValidationHelper.emailRegex);
    }
}

export { Email };
